<template>
    <div class="mt-1 clearfix">
        <div class="otherInfoLeft" :class="{'bold':record.bold}">{{record.knowledge}}:</div>
        <div class="otherInfoLeft bold ">{{$t(record.degree)}}</div>
    </div>
</template>

<script>
    export default {

        props: {
            record: {
                type: Object
            },
        },
        
    }
</script>

<style lang="scss" scoped>

</style>